import React from 'react';

const WarningOutlineIcon = ({ width = 12, height = 12, color = '#C22702' }) => (
  <svg
    width={width}
    height={height}
    viewBox={`0 0 12 12`}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.5 7.5H6.5V8.5H5.5V7.5ZM5.5 3.5H6.5V6.5H5.5V3.5ZM5.995 1C3.235 1 1 3.24 1 6C1 8.76 3.235 11 5.995 11C8.76 11 11 8.76 11 6C11 3.24 8.76 1 5.995 1ZM6 10C3.79 10 2 8.21 2 6C2 3.79 3.79 2 6 2C8.21 2 10 3.79 10 6C10 8.21 8.21 10 6 10Z"
      fill={color}
    />
  </svg>
);

export default WarningOutlineIcon;
